


































import { defineComponent, computed, ref } from '@vue/composition-api';
import passwordHandler from '@/renderer/components/user/compositions/passwordHandler';
import { httpUrl } from '@/renderer/scripts/http';
export default defineComponent({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    resetToken: {
      type: String,
      default: '',
    },
    newUserInfo: {
      type: Object,
      default: {
        id: -1,
        nickname: '',
        accountName: '',
        accountPassword: '',
      },
    },
  },
  setup(props, context) {
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });

    const { copyResetPasswordUrl } = passwordHandler();

    const resetPasswordUrl = ref('');
    const methods = {
      async init() {
        if (props.resetToken) {
          resetPasswordUrl.value = `${httpUrl.webUrl}/web/resetPassword/${encodeURIComponent(props.resetToken)}`;
        }
      },
      copyContent() {
        copyResetPasswordUrl({
          type: 'copyInviteUrl',
          url: resetPasswordUrl.value,
          nickname: props.newUserInfo.nickname,
          accountName: props.newUserInfo.accountName,
        });
      },
    };
    methods.init();
    return {
      innerShow,
      resetPasswordUrl,
      ...methods,
    };
  },
});
